import { ProfileColor } from "../../../dispatch/src/ProfileColor";
import { Checkbox, DataSource, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsProfile extends Layout {
    checkboxCollectionsUserExclude: Checkbox;
    checkboxCustomerExclude: Checkbox;
    checkboxNextActionExclude: Checkbox;
    layoutProfileColor: ProfileColor;
    sourceCollectionsProfile: DataSource;
    switchExcludeUnderThreshold: Switch;
    switchShowCollectionsUserBlank: Switch;
    switchShowItemsWithoutCalls: Switch;
    textboxAgeByDate: Textbox;
    textboxCollectionsUserIds: Textbox;
    textboxCustomerIds: Textbox;
    textboxCutoffDate: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxNextActionCodes: Textbox;
    textboxNextActionEndDate: Textbox;
    textboxNextActionStartDate: Textbox;
}
